import "./CreativeWealth.module.css";
import Navigation from "@/reusable_sections/Header";
import TheSelfMadePension from "./sections/TheSelfMadePension";
import KeyBenefits from "./sections/KeyBenefits";
import YourFinancialRoadmap from "./sections/YourFinancialRoadmap";
import AgencyFooter from "@/reusable_sections/Footer";
export default function CreativeWealthPage() {
  return <div>
      <Navigation />
      <TheSelfMadePension />
      <KeyBenefits />
      <YourFinancialRoadmap />
      <AgencyFooter />
    </div>;
}